import hashObject from "object-hash";
import { useMemo } from "react";

const useHashMemo = <T extends object | null | undefined>(value: T) => {
  const hash = value == null ? null : hashObject(value);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => value, [hash]);
};

export default useHashMemo;
